export interface Sequenced {
  sequence_num: number;
}

export function indexAfter(events: readonly Sequenced[], seq: number): number {
  let lo = 0;
  let hi = events.length;
  while (lo < hi) {
    const mid = (lo + hi) >>> 1;
    if (events[mid].sequence_num <= seq) lo = mid + 1;
    else hi = mid;
  }
  return lo;
}

export function insertBySequence<T extends Sequenced>(events: T[], event: T): void {
  const last = events[events.length - 1];
  if (last === undefined || last.sequence_num < event.sequence_num) {
    events.push(event);
    return;
  }
  const at = indexAfter(events, event.sequence_num);
  if (at > 0 && events[at - 1].sequence_num === event.sequence_num) {
    throw new Error(`event sequence_num ${event.sequence_num} is already in the window`);
  }
  events.splice(at, 0, event);
}
